import { sumBy } from 'lodash';

import './dashboard.scss';

import type { NavigateTo } from '@core/app/scripts/services/navigate-to';
import { CurrentSession } from '@shared/app/scripts/services/current-session';
import { DateSource } from '@shared/app/scripts/services/date-source';
import { DisplayMessage } from '@core/app/scripts/services/display-message';
import { Mask } from '@core/app/scripts/services/mask';
import { Persist } from '@core/app/scripts/services/persist';

/*
 * Component responsible for /dashboard route.
 */
angular
  .module('posApp')
  .directive(
    'dashboard',
    (
      $q: ng.IQService,
      currentSession: CurrentSession,
      dateSource: DateSource,
      displayMessage: DisplayMessage,
      locationManager,
      mask: Mask,
      moment,
      navigateTo: NavigateTo,
      persist: Persist,
      salesReports,
      translate: ng.translate.ITranslateService,
    ) => ({
      restrict: 'E',

      scope: true,

      template: require('./dashboard.html').default,

      link: function ($scope, element, attrs) {
        const $translate = translate;

        $scope.filterBy = 'location';

        $scope.navigateToView = (view) => {
          navigateTo(view);
        };

        $scope.onChange = () => {
          persist.set('posDashboardFilterBy', $scope.filterBy);
          $scope.loadDashboardData();
        };

        $scope.getFilterByDisplayName = () => {
          if ($scope.filterBy === 'device') {
            return $scope.username;
          } else {
            return $scope.warehouseName;
          }
        };

        $scope.warehouses = locationManager.all;
        $scope.warehouseName = locationManager.current.name;
        $scope.username = currentSession.username;

        if (persist.get('posDashboardFilterBy')) {
          $scope.filterBy = persist.get('posDashboardFilterBy');
        }

        //This function will run whenever the page is shown
        $scope.loadDashboardData = () => {
          displayMessage.showLoading();

          if ($scope.filterBy === 'device') {
            $scope.deviceId = currentSession.userId;
            $scope.warehouseId = undefined;
          } else {
            $scope.warehouseId = currentSession.warehouse;
            $scope.deviceId = undefined;
          }

          const startDate = moment(dateSource.now()).startOf('day').toDate(),
            endDate = moment(dateSource.now()).toDate();

          $q.all([
            salesReports.getSummary(
              startDate,
              endDate,
              $scope.warehouseId,
              $scope.deviceId,
            ),
            salesReports.getPerCategory(
              startDate,
              endDate,
              'brand',
              $scope.deviceId,
            ),
            salesReports.getPerCategory(
              startDate,
              endDate,
              'articleGroup',
              $scope.deviceId,
            ),
          ]).then(
            (responseArray) => {
              // maps ng1.7 solution
              const response = {
                summary: responseArray[0],
                perBrand: responseArray[1],
                perArticleGroup: responseArray[2],
              };

              $scope.nr_receipts = response.summary.itemTransactions;
              $scope.avg_amount = response.summary.totalPer;
              $scope.avg_pcs = response.summary.nettItemsPer;
              $scope.nr_pieces = response.summary.items;
              $scope.nr_returns = response.summary.returns;
              $scope.turnover = response.summary.turnover;
              $scope.discount = response.summary.totalDiscount;
              $scope.KU = response.summary.KU;
              $scope.withdrawal = response.summary.withdrawal;
              $scope.consignment = response.summary.consignment;

              $scope.perBrand = response.perBrand;

              $scope.perBrandTotal = sumBy(response.perBrand, 'turnover');

              $scope.perArticleGroup = response.perArticleGroup;

              $scope.perArticleGroupTotal = sumBy(
                response.perArticleGroup,
                'turnover',
              );

              $scope.today = moment(dateSource.now()).toDate();

              $scope.perBrand;

              mask.hide();
            },
            () => {
              displayMessage.message($translate.instant('ServerError'));
            },
          );
        };

        $scope.loadDashboardData();
      },
    }),
  );
